import type { JSX } from 'react';
import { useState } from 'react';
import { Alert, Button, Card, Form, Input, Typography } from 'antd';
import { RobotOutlined } from '@ant-design/icons';

import { authApi } from '../lib/authApi';

/** Логин CRM-учёткой (email + пароль) — тот же /api/auth/login. */
export function LoginPage({ onLoggedIn }: { onLoggedIn: () => void }): JSX.Element {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const onFinish = async (values: { email: string; password: string }) => {
    setLoading(true);
    setError(null);
    try {
      await authApi.login(values.email.trim(), values.password);
      onLoggedIn();
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Не удалось войти');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#251D4A',
      }}
    >
      <Card style={{ width: 380, borderRadius: 16 }} styles={{ body: { padding: 32 } }}>
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <RobotOutlined style={{ fontSize: 40, color: '#FF6900' }} />
          <Typography.Title level={4} style={{ margin: '8px 0 0 0' }}>
            ВК-бот БРАСОЛ
          </Typography.Title>
          <Typography.Text type="secondary" style={{ fontSize: 13 }}>
            Вход учёткой CRM (crm.brasol.ru)
          </Typography.Text>
        </div>
        {error && (
          <Alert type="error" message={error} showIcon style={{ marginBottom: 16 }} />
        )}
        <Form layout="vertical" onFinish={onFinish} requiredMark={false}>
          <Form.Item
            label="Email"
            name="email"
            rules={[{ required: true, message: 'Введите email' }]}
          >
            <Input autoComplete="username" size="large" />
          </Form.Item>
          <Form.Item
            label="Пароль"
            name="password"
            rules={[{ required: true, message: 'Введите пароль' }]}
          >
            <Input.Password autoComplete="current-password" size="large" />
          </Form.Item>
          <Button type="primary" htmlType="submit" block size="large" loading={loading}>
            Войти
          </Button>
        </Form>
      </Card>
    </div>
  );
}
